/** Joint3D parser: the Node3D transform surface plus `node_a` and `node_b`. */
import { parseNodePathLiteral } from '../../../../parser/valueParsers';
import { parseNode3D } from '../../../base/node3d/parser';
export function parseJoint3D(heading, properties) {
    return {
        ...parseNode3D(heading, properties),
        node_a: parseNodePathLiteral(properties.node_a) || undefined,
        node_b: parseNodePathLiteral(properties.node_b) || undefined,
    };
}
//# sourceMappingURL=parser.js.map